export const columnKeys: Record<string, { display: string; value: string }> = {
    '': { display: 'None', value: '' },
    firmDisplayName: {
        display: 'Company',
        value: 'firmDisplayName',
    },
    type: {
        display: 'Listing type',
        value: 'type',
    },
    sectionNumber: {
        display: 'Family',
        value: 'sectionNumber', // Family number + Family name combined
    },
    productType: {
        display: 'Product type',
        value: 'productType',
    },
    submissionStatus: {
        display: 'State',
        value: 'submissionStatus',
    },
    lastUpdated: {
        display: 'Publish date',
        value: 'lastUpdated',
    },
    isActive: {
        display: 'Status',
        value: 'isActive',
    },
}
